exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgSizeMedium[data-v-634d1bae]{width:90px;height:120px;overflow:hidden;border-radius:4px;display:inline-block}.imgSizeSmall[data-v-634d1bae]{width:60px;height:80px;overflow:hidden;border-radius:4px;display:inline-block}.imgSizeLarge[data-v-634d1bae]{width:168px;height:224px;overflow:hidden;border-radius:4px;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-634d1bae","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/CoverImg/index.vue
// module id = 714
// module chunks = 0